module.exports = __webpack_public_path__ + "img/desc_bottom_bl3fl02.f748f7b8.png";